<template>
  <p class="mt-1 mb-1" style="height: 28px">
    <span v-if="isSending">
      <!-- <img src="@/assets/animations/loader-dots-black.svg" width="25" height="25" class="mx-auto" /> -->
      <strong>J.L. AI</strong> est en train d'écrire...
    </span>
  </p>
</template>

<script>
export default {
  name: "Sending",
  props: {
    isSending: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
